import config from '../config/config';

const FULL_SCREEN_SELECTOR = config.map.fullScreen.selectorFullScreen;

/**
 * 要素をフルスクリーン表示する関数
 * @param {HTMLElement} element - フルスクリーン表示する要素
 */
export const toggleMapContentFullScreen = () => {
  const mapContent = document.querySelector(FULL_SCREEN_SELECTOR);
  if (mapContent) {
    return toggleMapFullScreen(mapContent);
  }
  return Promise.resolve(false);
};

export const toggleMapFullScreen = (element = document.documentElement) => {

  if (!document.fullscreenElement) {
    // フルスクリーン開始
    if (element.requestFullscreen) {
      return element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      return element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      return element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      return element.msRequestFullscreen();
    }
  } else {
    // フルスクリーン終了
    if (document.exitFullscreen) {
      return document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      return document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      return document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      return document.msExitFullscreen();
    }
  }
  return Promise.resolve();
};